/* tslint:disable */
/* eslint-disable */
/**
 * Контроль місій для FPV
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RepositoriesWindMapPoint
 */
export interface RepositoriesWindMapPoint {
    /**
     * 
     * @type {number}
     * @memberof RepositoriesWindMapPoint
     */
    lat?: number;
    /**
     * 
     * @type {number}
     * @memberof RepositoriesWindMapPoint
     */
    lng?: number;
    /**
     * 
     * @type {number}
     * @memberof RepositoriesWindMapPoint
     */
    uMs?: number;
    /**
     * 
     * @type {number}
     * @memberof RepositoriesWindMapPoint
     */
    vMs?: number;
}

/**
 * Check if a given object implements the RepositoriesWindMapPoint interface.
 */
export function instanceOfRepositoriesWindMapPoint(value: object): boolean {
    return true;
}

export function RepositoriesWindMapPointFromJSON(json: any): RepositoriesWindMapPoint {
    return RepositoriesWindMapPointFromJSONTyped(json, false);
}

export function RepositoriesWindMapPointFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepositoriesWindMapPoint {
    if (json == null) {
        return json;
    }
    return {
        
        'lat': json['lat'] == null ? undefined : json['lat'],
        'lng': json['lng'] == null ? undefined : json['lng'],
        'uMs': json['uMs'] == null ? undefined : json['uMs'],
        'vMs': json['vMs'] == null ? undefined : json['vMs'],
    };
}

export function RepositoriesWindMapPointToJSON(value?: RepositoriesWindMapPoint | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'lat': value['lat'],
        'lng': value['lng'],
        'uMs': value['uMs'],
        'vMs': value['vMs'],
    };
}

